import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { clientStatusLabel, deliverableStage, metaLabel, stageHeading } from '../../utils/deliverables';
import { projectStatus } from '../../utils/status';
import { formatShootDate, isUpcoming } from '../../utils/time';
export function Project() {
  const {
    activeProject
  } = usePortal();
  const nextShootDate = isUpcoming(activeProject.nextShootDate) ? activeProject.nextShootDate : '';
  const rows = [{
    label: 'Client',
    value: activeProject.client
  }, {
    label: 'Project',
    value: activeProject.name
  }, {
    label: 'Type',
    value: activeProject.type
  }, {
    label: 'Status',
    value: projectStatus(activeProject)
  }, {
    label: 'Next Shoot',
    value: nextShootDate ? [formatShootDate(nextShootDate), activeProject.nextShootTime].filter(Boolean).join(' · ') : 'To be confirmed'
  }, {
    label: 'Location',
    value: nextShootDate ? activeProject.location || '—' : '—'
  }].filter(row => row.value);
  const visible = activeProject.deliverables.filter(item => item.visibleToClient);
  return <div data-id="element-663" data-mp="3th3m8id2s1wo">
      <h1 className="font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl" data-id="element-664" data-mp="3thc1ggwo7jb1">PROJECT</h1>
      {activeProject.description && <p className="mt-8 max-w-2xl font-display text-xl leading-snug text-charcoal" data-id="element-665" data-mp="b8kvfbyxjilv">
          {activeProject.description}
        </p>}

      <div className="mt-16 grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-666" data-mp="l8buzs2cknst">
        <section aria-label="Project details" className="lg:col-span-7" data-id="element-667" data-mp="ga1vx6di531x">
          <dl className="m-0 border-t border-rule" data-id="element-668" data-mp="g7o1mzqnbuvf">
            {rows.map(row => <div key={row.label} className="flex flex-wrap items-baseline justify-between gap-4 border-b border-rule py-6" data-id="element-669" data-mp="uxv9ymmxvxie">
                <dt className="label m-0 text-mute" data-id="element-670" data-mp="140e9awrinrzw">{row.label}</dt>
                <dd className="m-0 max-w-md text-right font-display text-2xl leading-tight sm:text-3xl" data-id="element-671" data-mp="z0jisubnl4fd">
                  {row.value}
                </dd>
              </div>)}
          </dl>
        </section>

        <section aria-labelledby="deliverables" className="lg:col-span-5 lg:border-l lg:border-rule lg:pl-12" data-id="element-672" data-mp="1n006jiry3s7">
          <h2 id="deliverables" className="label border-b border-rule pb-4 text-graphite" data-id="element-673" data-mp="5lfhq7w36jy8">
            Deliverables
          </h2>
          <ul className="m-0 list-none p-0" data-id="element-674" data-mp="fdljuag1yhr5">
            {visible.length === 0 && <li className="py-6 font-display text-lg text-mute" data-id="element-675" data-mp="kcg2nce0s6b9">
                Deliverables are being confirmed.
              </li>}
            {visible.map(item => <li key={item.id} className="border-b border-rule py-6" data-id="element-676" data-mp="p9ollf6zsedk">
                <p className="font-display text-2xl leading-none" data-id="element-677" data-mp="tckz4rhodkan">{item.name}</p>
                <p className="label-sm mt-3 text-mute" data-id="element-678" data-mp="2r3xmvo55t2vy">
                  {metaLabel(item)} · {stageHeading(deliverableStage(item.status))} ·{' '}
                  {clientStatusLabel(item.status)}
                </p>
              </li>)}
          </ul>
        </section>
      </div>
    </div>;
}